import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRedwoodjsComponent } from './simple-icons-redwoodjs.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRedwoodjsComponent ],
    exports:      [ SimpleIconsRedwoodjsComponent ],
    bootstrap:    []
})
export class SimpleIconsRedwoodjsModule {}
